import { useState } from 'react';

import { StyledVideo } from '../MessageAttachments/MessageAttachmentsStyles';
import { TAttachmentRendererProps } from '../../helpers';

const VideoAttachment = ({ attachment }: TAttachmentRendererProps) => {
  const [src] = useState(attachment.url);
  const [failed, setFailed] = useState(false);

  const handleError = () => setFailed(true);

  if (failed) return null;

  return (
    <StyledVideo
      src={src}
      controls
      playsInline
      preload="metadata"
      controlsList="nodownload"
      onError={handleError}
    />
  );
};

export default VideoAttachment;
